import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import Swal from 'sweetalert2'
const db = getFirestore();

async function filtrarDatos(stringBusqueda, baseDatos, ruc) {
  const docusFiltrado = [];

  const collecionRef = collection(db, baseDatos);
  const queryDNI = query(
    collecionRef,
    where("dni", "==", stringBusqueda)
    ,where("rucEmpresa", "==", ruc)
  );
  const queryEmail = query(
    collecionRef, 
    where("email", "==", stringBusqueda)
    ,where("rucEmpresa", "==", ruc));

  const arraySnapshots = await Promise.all([
    getDocs(queryDNI),
    getDocs(queryEmail),
  ]);

  arraySnapshots.forEach((snapshot) => {
    snapshot.forEach((doc) => {
      docusFiltrado.push(doc.data());
    });
  });

  if(docusFiltrado.length===0){
    Swal.fire({
      position: 'center',
      icon: 'error',
      title: 'No tiene autorización para ver esta información',
      showConfirmButton: false,
      timer: 2000
    })

    return null;
  } else {
    return docusFiltrado;
  }
  
}

export default filtrarDatos;
